import { Component, Input } from '@angular/core';
import { Summary } from './summary.interface';

@Component({
    selector: 'ols-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent {
    @Input() summary: Summary;
    isImageReady = false;

    constructor() {}

    imageIsReady(): void {
        this.isImageReady = true;
    }
}
